import { createSlice } from "@reduxjs/toolkit";
import { getLocalStorageData } from "../../shared/commonFunction";

const STORAGE_KEY = "duelsJoinRequests";

const getInitialState = () => {
  try {
    const cached = getLocalStorageData(STORAGE_KEY);
    if (!cached) {
      return {
        requests: [],
        lastUpdated: null,
      };
    }

    const parsed = JSON.parse(cached);
    return {
      requests: Array.isArray(parsed?.requests) ? parsed.requests : [],
      lastUpdated: parsed?.lastUpdated || null,
    };
  } catch (error) {
    console.error("Failed to parse cached join requests:", error);
    return {
      requests: [],
      lastUpdated: null,
    };
  }
};

const joinRequestSlice = createSlice({
  name: "joinRequest",
  initialState: getInitialState(),
  reducers: {
    setJoinRequestFromSocket: (state, action) => {
      state.requests = Array.isArray(action.payload) ? action.payload : [];
      state.lastUpdated = new Date().toISOString();
    },
    removeJoinRequestById: (state, action) => {
      state.requests = state.requests.filter(
        (request) => request?._id !== action.payload
      );
      state.lastUpdated = new Date().toISOString();
    },
    clearJoinRequests: (state) => {
      state.requests = [];
      state.lastUpdated = null;
    },
  },
});

export const {
  setJoinRequestFromSocket,
  removeJoinRequestById,
  clearJoinRequests,
} = joinRequestSlice.actions;
export const selectJoinRequests = (state) => state.joinRequest?.requests || [];
export const selectJoinRequestCount = (state) =>
  state.joinRequest?.requests?.length || 0;
export const DUELS_JOIN_REQUEST_STORAGE_KEY = STORAGE_KEY;
export default joinRequestSlice.reducer;
